import { AppBar, IconButton, Typography } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';
import { History } from '@material-ui/icons';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import React, { useCallback, useState } from 'react';
import { getEnvVariable } from '../../modules/environmentalList';

const defaultDrawerWidth = 900;
const minDrawerWidth = 900;
const maxDrawerWidth = window.innerWidth - 220;
const fullscreenwidth = window.innerWidth
const checkwidth = 960

const useStyles = makeStyles(theme => ({
    drawer: {
        flexShrink: 0
    },
    dragger: {
        width: "7px",
        cursor: "ew-resize",
        padding: "4px 0 0",
        borderTop: "1px solid #ddd",
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: 100,
        //   backgroundColor: "#f4f7f9"
    }
}));
// const versionHistory = [
//     {
//         releaseDate: '12/14/2023',
//         versionNumber: '1.0.2',
//         status: 'New',
//         description: [
//             { name: 'On hover menu item highlight', },
//             { name: 'Version history moved to side pop up', },
//             { name: '"my portal " is added now records, company and reports comes under my portal ' },
//         ],
//         Tasklink: { link: 'https://dev.azure.com/delasoft/ADOT%20AEPS/_workitems/edit/84051', name: 'Task: 84051' }
//     },
//     {
//         releaseDate: '12/1/2023',
//         versionNumber: '1.0.2',
//         status: 'New',
//         description: [
//             { name: 'Profile:Option provided at "Profile" to switch the manu bar to top for left options as user selection. This will last until user clears the local storage or clear cookies' },
//             { name: 'Grid:  on hover filter icon will be displayed,row spacing is increased' },
//             { name: 'Notification: checkbox is added based on the switch is multiple.' },
//             { name: 'Notification: New,Read, UnRead and Dismissed options are displayed at breadcrumbs, on multi select checkboxes will be displayed,Read,Unread and Dismissed buttons are disabled unless checkbox', },
//             { name: 'Notification:  Pending Registration Request is changed to Menu option from Popup' },
//         ],
//         Tasklink: { link: 'https://dev.azure.com/delasoft/ADOT%20AEPS/_workitems/edit/84051', name: 'Task: 84051' }
//     },
//     {
//         releaseDate: '11/29/2023',
//         versionNumber: '1.0.0',
//         status: 'New',
//         description: [
//             { name: 'Left sidebar menu option to open and close- default Close', },
//             { name: 'Greetings,User highest role  are added inside the Profile', },
//             { name: 'Added new menu option for Release Notes inside Profile to navigate to current version details' },
//             { name: 'Breadcrumbs separator is changed to >', link: '#/Administration/agencyusers' },
//             { name: 'Grid: Status column displays Active and Inactive  tags in Green and Red', link: '#/Administration/agencyusers' },
//             { name: 'Record screen each sections card view, display is changed.', link: '#/Administration/agencyusers' },
//         ],
//         Tasklink: { link: 'https://dev.azure.com/delasoft/ADOT%20AEPS/_workitems/edit/84051', name: 'Task: 84051' }
//     },


//     // Add more versions as needed
// ];
const VersionHistory = (props) => {
    const { handleBackSlider } = props
    const [drawerWidth, setDrawerWidth] = useState((props.width === "sm" || props.width === "xs" || props.width === "md") ? fullscreenwidth : defaultDrawerWidth);
    const [fullscreen, setFullScreen] = useState(false)
    const [fullwidth, setFullWidth] = useState(fullscreenwidth)
    let screensize = (props.width === "sm" || props.width === "xs" || props.width === "md") ? false : true
    React.useEffect(() => {
        window.addEventListener("resize", updateWidth);
        return () => window.removeEventListener("resize", updateWidth);
    });

    const updateWidth = () => {
        if (window.innerWidth < checkwidth) {
            setDrawerWidth(window.innerWidth);
        }
        else {
            setDrawerWidth(defaultDrawerWidth)
        }
    };

    React.useEffect(() => {
        if (!screensize) {
            let width = window.innerWidth
            setDrawerWidth(width);
            setFullWidth(width)
        }
        else {
            setDrawerWidth(defaultDrawerWidth);
            // setFullWidth(defaultDrawerWidth)
        }
    }, [props.width]);


    const handleMouseDown = e => {
        document.addEventListener("mouseup", handleMouseUp, true);
        document.addEventListener("mousemove", handleMouseMove, true);
    };

    const handleMouseUp = () => {
        document.removeEventListener("mouseup", handleMouseUp, true);
        document.removeEventListener("mousemove", handleMouseMove, true);
    };

    const handleMouseMove = useCallback(e => {
        let newWidth =
            document.body.offsetWidth - (e.clientX - document.body.offsetLeft);
        //  const newWidth = e.clientX - document.body.offsetLeft;
        if (newWidth > minDrawerWidth && newWidth < maxDrawerWidth) {
            setDrawerWidth(newWidth);
        }
    }, []);



    const classes = useStyles();
    return (
        <Drawer disableEnforceFocus={true} anchor="right"
            disableAutoFocus={true}
            PaperProps={{
                style: {
                    width: fullscreen ? fullwidth : drawerWidth,
                    backgroundColor: 'rgb(230, 237, 241)'
                }
            }}
            open={true} onClose={() => handleBackSlider(false)}
        >
            <div style={{ overflow: 'auto', height: '100%' }}>
                <div  onMouseDown={e => handleMouseDown(e)} className={classes.dragger} />
                <AppBar className=' ml-4 mb-1 mr-3 mt-3 'style={{width:'93%', margin:'1px' }} position="sticky"elevation={0}  >
                    <Typography className='m-2' color='primary'>
                        <History className='mx-1' />Release Notes<IconButton className='float-end'  size='small'color="primary" aria-label="save" component="span" onClick={() => handleBackSlider(true)} >
                            <ChevronLeftIcon  /></IconButton></Typography>
                    {/* <Typography className='ps-2' color='primary'>
                <IconButton color="primary" aria-label="save" component="span" onClick={() =>  handleBackSlider(true)} >
                     <BackIcon /></IconButton></Typography> */}
                </AppBar>
                <div />
                <div className='col-12 '>
                    <iframe className='col' height={window.innerHeight - 90} width={'97%'} src={`${getEnvVariable('HelpUI')}${getEnvVariable('VersionHistoryLink')}?view=embedded`} name="iFrameName" title="Help UI"></iframe>
                </div>
                {/* {versionHistory.map((version, index) => (
                <Card style={{ borderRadius: '15px', margin: 10, padding: 3 }}>
                    <CardTitle style={{ fontSize: '18px', margin: 5, padding: 5 }} >{`Version ${version.versionNumber}`}
                        <Chip className='mx-3' rounded label={version.status} variant="outlined" />
                    </CardTitle>
                    <CardSubtitle style={{ margin: 5, padding: 5 }} >{`Released on ${version.releaseDate}`}</CardSubtitle>
                    {version && version.Tasklink &&
                        <Link className='mx-2' href={version.Tasklink.link} target="_blank" >{version.Tasklink.name || 'N/A'}</Link>}
                    <CardContent >
                        <List>
                            {version.description && version.description.map(each => {
                                return <ListItem key={index} style={{ margin: 0, padding: 2 }}>
                                    <ListItemIcon>
                                        <FiberManualRecordIcon />
                                    </ListItemIcon>
                                    <ListItemText style={{ fontSize: 10 }}
                                        primary={
                                            each.link ? <Link href={each.link} color='inherit'>
                                                {each.name}
                                            </Link> : each.name}
                                    />
                                </ListItem>
                            })}
                        </List>
                    </CardContent>
                </Card>
            ))} */}
            </div>
        </Drawer>
    );
};

export default VersionHistory;
